import { defineMessages } from "@/i18n";
import en from "./en";

export const focusMessages = defineMessages("focus", en);
